import { render } from "./SkeletonProfileButton.vue?vue&type=template&id=1735fc78&scoped=true"
import script from "./SkeletonProfileButton.vue?vue&type=script&lang=js"
export * from "./SkeletonProfileButton.vue?vue&type=script&lang=js"

import "./SkeletonProfileButton.vue?vue&type=style&index=0&id=1735fc78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1735fc78"
/* hot reload */
if (module.hot) {
  script.__hmrId = "1735fc78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1735fc78', script)) {
    api.reload('1735fc78', script)
  }
  
  module.hot.accept("./SkeletonProfileButton.vue?vue&type=template&id=1735fc78&scoped=true", () => {
    api.rerender('1735fc78', render)
  })

}

script.__file = "src/ui/skeleton/profile/SkeletonProfileButton.vue"

export default script